"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = require("react");
const CTAMessage_1 = __importDefault(require("../../sample/CTAMessage"));
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const AccountSpecifications_1 = __importDefault(require("../../sample/AccountSpecifications"));
const SkipTestingModal_1 = __importDefault(require("../../sample/SkipTestingModal"));
const hookUrlStyle = core_1.css `
  font-family: monospace;
`;
const EventNotFound = (props) => {
    const noun = lodash_1.lowerCase(props.noun);
    const headerText = `We couldn’t find ${common_utils_1.prefixWithArticle(noun)}`;
    const message = props.isWebhook === true && props.webhookUrl ? (core_1.jsx(react_1.Fragment, null,
        "Send a new request to this webhook URL:",
        ' ',
        core_1.jsx("span", { css: hookUrlStyle }, props.webhookUrl),
        " and test your trigger again.")) : props.isWebhook === true && !props.webhookUrl ? (core_1.jsx(react_1.Fragment, null, "Verify that your webhook returns an event and test your trigger again.")) : (core_1.jsx(react_1.Fragment, null,
        "Create a new ",
        noun,
        " in your",
        ' ',
        core_1.jsx(AccountSpecifications_1.default, { authTitle: props.authTitle, hasServiceAuthType: props.hasServiceAuthType, serviceKey: props.serviceKey, serviceName: props.serviceName }),
        ' ',
        "and test your trigger again."));
    const [isConfirming, setConfirming] = react_1.useState(false);
    const onConfirm = () => setConfirming(true);
    const onCancel = () => setConfirming(false);
    return (core_1.jsx(react_1.Fragment, null,
        core_1.jsx(CTAMessage_1.default, { emojiLabel: "magnifying glass", emojiSymbol: '🔍', headerText: props.notFoundHeader || headerText, illustration: props.notFoundIllustration, isWaiting: props.isTesting, message: props.notFoundMessage || message, onPrimaryButtonClick: props.onTest, onSecondaryButtonClick: onConfirm, primaryButtonText: "Test trigger", secondaryButtonText: "Skip test", waitingText: "Testing" }),
        isConfirming && (core_1.jsx(SkipTestingModal_1.default, { onCancel: onCancel, onSkip: props.onSkip }))));
};
exports.default = EventNotFound;
